// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filters-list__list{max-height:400px;overflow-y:auto\n}\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/sass-resources-loader/lib/loader.js?{"sourceMap":true,"resources":["/Users/serg/projects/gpn-prod/frontend/styles/vars/colors/_colors.scss","/Users/serg/projects/gpn-prod/frontend/styles/vars/_vars.scss","/Users/serg/projects/gpn-prod/frontend/styles/base/_a-mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./frontend/components/filters-list/filters-list.vue
// module id = 135
// module chunks = 0